import {marketMap, MarketMap} from "./chart/MarketMapComponent";
import {marketMapWidget, MarketMapWidget} from "./widget/MarketMapWidgetComponent";

export default function(parentModule: string): string {
    const module = `${parentModule}.components`;
    return angular.module(module, [])
                  .component(MarketMap, marketMap())
                  .component(MarketMapWidget, marketMapWidget())
                  .name;
}